import Contact from "../../components/Contact";
import Hero from "../../components/Hero";
import Marque from "../../components/Marque";
import Blogs from "./Blogs";
import Info from "./Info";
import Services from "./Services";
import Testimonials from "./Testimonials";

import { ScrollRestoration, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getAllBlogs } from "../blog/apiCall";
import createUrl from "../../utils/createUrl";
import axios from "axios";

const Home = () => {
  const [hero, setHero] = useState("");
  const [heroMob, setHeroMob] = useState("");
  const [blog, setBlog] = useState([]);
  const location = useLocation().hash;
  const navigate = useNavigate();

  useEffect(() => {
    let pageNo: any = 1;

    axios({
      url: "https://api.shopiq.app/api/contents/?identifier=bionadvisors.com",
      method: "get",
    })
      .then((res: any) => {
        setHero(res.data.contents[0].hero[0].mediaUrl);
        setHeroMob(res.data.contents[0].hero[0].mobMediaUrl);
      })
      .catch((err: any) => {
        console.log(err);
      });

    getAllBlogs(pageNo)
      .then((data) => {
        console.log("blogs are : ", data.blogs);
        createUrl(data.blogs[0].title);
        setBlog(
          data.blogs
            .sort((a: any, b: any) => a.priority - b.priority)
            .splice(0, 3)
        );
        if (location === "#contact") {
          navigate("#contact");
        }
      })
      .catch((e) => console.log(e));
  }, []);

  return (
    <>
      <ScrollRestoration />
      <Hero
        text="We empower your business with our financial expertise."
        fontSize="6rem"
        videoSrc={window.innerWidth < 800 ? hero : heroMob}
        isLandingPage={true}
      />
      <div>
        <Info />
      </div>
      <Services />
      <Marque title="Clients" bg="#EF8600" textColor="#fff" />
      <Testimonials />

      {blog.length !== 0 && <Blogs data={blog} />}
      <Contact />
    </>
  );
};

export default Home;
